import React from 'react';
import { Check, X } from 'lucide-react';
import { motion } from 'framer-motion';
interface CheckListProps {
  items: string[];
  type?: 'success' | 'error' | 'neutral';
  title?: string;
}
export function CheckList({
  items,
  type = 'success',
  title
}: CheckListProps) {
  const getIcon = () => {
    switch (type) {
      case 'success':
        return <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-30" />;
      case 'error':
        return <X className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-31" />;
      default:
        return <div className="w-2 h-2 rounded-full bg-slate-400 mt-2 flex-shrink-0" data-id="element-32" />;
    }
  };
  return <div className="my-6" data-id="element-33">
      {title && <h4 className="font-bold text-lg mb-3 text-slate-800" data-id="element-34">{title}</h4>}
      <ul className="space-y-3" data-id="element-35">
        {items.map((item, index) => <motion.li key={index} initial={{
        opacity: 0,
        x: -10
      }} whileInView={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: index * 0.1
      }} viewport={{
        once: true
      }} className="flex items-start gap-3 text-slate-700 leading-relaxed" data-id="element-36">
            {getIcon()}
            <span data-id="element-37">{item}</span>
          </motion.li>)}
      </ul>
    </div>;
}